import { CommonUtility } from '../common';
import { APIPath } from '../constants';
import { BaseService } from './base';
import { CRUDService } from './crud.ts';

class Inventory extends CRUDService {
  constructor() {
    super(APIPath.inventory);
  }

  generateUploadLInk(feedType, params) {
    const query = CommonUtility.objectToParams(params);
    return BaseService.get(`${APIPath.inventoryFeedUploadUrl}/${feedType}/?${query}`);
  }

  getFeeds(params) {
    const query = CommonUtility.objectToParams(params);
    return BaseService.get(`${APIPath.inventoryFeed}/?${query}`);
  }

  updateInventory(id, payload) {
    return BaseService.patch(`${APIPath.inventory}/${id}`, payload);
  }

  deleteInventory(payload) {
    return BaseService.deleteWithBody(`${APIPath.inventory}`, payload);
  }

  getInventoryProposals(body) {
    return BaseService.post(APIPath.inventoryProposals, body);
  }

  getInventoryLocation(warehouseId, params) {
    return BaseService.get(
      `${
        APIPath.ordersInventoryLocationsDropdown
      }/${warehouseId}/?${CommonUtility.objectToParams(params)}`,
    );
  }

  getInventoryTranfers(params) {
    const query = CommonUtility.objectToParams(params);
    return BaseService.get(`${APIPath.inventoryTransfers}/?${query}`);
  }

  cancelInventoryTransfer(transferId, payload = {}) {
    const url = `${APIPath.inventoryTransfers}/${transferId}`;
    if (payload && Object.keys(payload).length > 0) {
      return BaseService.deleteWithBody(url, payload);
    }
    return BaseService.remove(url);
  }

  getInventorySuggestedTranfers(params) {
    const query = CommonUtility.objectToParams(params);
    return BaseService.get(`${APIPath.inventoryTransfersSuggested}/?${query}`);
  }

  refreshSuggestedTransfers(data) {
    return BaseService.post(APIPath.inventorySuggestedTransfersRefresh, data);
  }

  getSuggestedTransferRefreshStatus(params) {
    const query = CommonUtility.objectToParams(params);
    return BaseService.get(
      `${APIPath.inventorySuggestedTransfersRefreshStatus}?${query}`,
    );
  }

  updateSuggestedTransfer(suggestedTransferId, payload) {
    return BaseService.patch(
      `${APIPath.inventorySuggestedTransfer}/${suggestedTransferId}`,
      payload,
    );
  }

  deleteSuggestedTransfer(suggestedTransferId) {
    return BaseService.remove(
      `${APIPath.inventorySuggestedTransfer}/${suggestedTransferId}`,
    );
  }

  createReplenishmentWave(payload) {
    return BaseService.post(APIPath.inventoryReplenishmentWaves, payload);
  }

  getReplenishmentWaves(params) {
    const query = CommonUtility.objectToParams(params);
    return BaseService.get(`${APIPath.inventoryReplenishmentWaves}/?${query}`);
  }

  deleteReplenishmentWaveLine(waveId, transferLineId, warehouseId) {
    const query =
      warehouseId != null && warehouseId !== ''
        ? `?${CommonUtility.objectToParams({ warehouseId })}`
        : '';
    return BaseService.remove(
      `${APIPath.inventoryReplenishmentWaves}/${waveId}/lines/${transferLineId}${query}`,
    );
  }

  getInventoryHistory(inventoryId, params) {
    const query = CommonUtility.objectToParams(params);
    return BaseService.get(`${APIPath.inventory}/${inventoryId}/history/?${query}`);
  }

  editAttribute(itemId, data) {
    return BaseService.put(`${APIPath.items}/${itemId}/packageDimensions`, data);
  }

  updateLotAttribute(itemId, inventoryId, data) {
    return BaseService.put(
      `${APIPath.items}/${itemId}/cartonAttributes/?inventoryId=${inventoryId}`,
      data,
    );
  }

  getLotAttributes(id) {
    return BaseService.get(`${APIPath.items}/${id}/cartonAttributes`);
  }

  getRelatedSku(params) {
    return BaseService.get(
      `${APIPath.inventoryErpSkuSearch}/?${CommonUtility.objectToParams(params)}`,
    );
  }

  checkInInventory(data) {
    return BaseService.post(APIPath.inventory, data);
  }

  replenishmentInventory(params) {
    return BaseService.get(
      `${APIPath.inventoryStockAlerts}/?${CommonUtility.objectToParams(params)}`,
    );
  }

  replenishmentInventoryConsolidated(params) {
    return BaseService.get(
      `${
        APIPath.inventoryStockAlertsConsolidated
      }/?${CommonUtility.objectToParams(params)}`,
    );
  }

  replenishmentInventoryConsolidatedExport(params) {
    const query = CommonUtility.objectToParams(params);
    return BaseService.getWithFullResponse(
      `${APIPath.inventoryExportConsolidated}?${query}`,
    );
  }

  inventoryExport(params) {
    const query = CommonUtility.objectToParams(params);
    return BaseService.getWithFullResponse(`${APIPath.inventoryExport}?${query}`);
  }

  getInventoryExportFeeds(params) {
    const query = CommonUtility.objectToParams(params);
    return BaseService.get(`${APIPath.inventoryExportFeeds}?${query}`);
  }

  createInventoryExportFeed(params) {
    const query = CommonUtility.objectToParams(params);
    return BaseService.post(`${APIPath.inventoryExportFeed}?${query}`);
  }

  ignoreItem(itemId) {
    return BaseService.put(`${APIPath.inventoryItems}/${itemId}/ignore`);
  }

  activateItem(itemId) {
    return BaseService.put(`${APIPath.inventoryItems}/${itemId}/activate`);
  }
}

const InventoryService = new Inventory();
Object.freeze(InventoryService);
export { InventoryService };
